import styled from 'styled-components';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { ReactComponent as ArrowNavIcon } from '../../../../../../../images/ui/arrow-nav.svg';
import { ReactComponent as InfoIcon } from '../../../../../../../images/ui/info-icon.svg';

const ContainerStyled = styled.div`
  padding: 18px 24px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  background-color: ${({ disabled }) => (disabled ? '#E2E6EA' : '#fff')};
  border: ${({ disabled }) => (disabled ? '1px solid #C9CFD7' : 'none')};
  width: 100%;
  margin-bottom: 15px;
  border-radius: 7px;
`;

const TextInvoice = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: ${({ disabled }) => (disabled ? '#8D94A5' : '#381451')};
`;

ContainerStyled.propTypes = {
  disabled: PropTypes.bool.isRequired,
};

ContainerStyled.defaultProps = {
  disabled: false,
};

const HeaderStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

const TextStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: start;
  justify-content: center;
  user-select: none;
  color: ${({ disabled }) => (disabled ? '#8D94A5' : '#000')};
`;

const HandleStyled = styled(ArrowNavIcon)`
  cursor: pointer;
  transform: ${props => (props.toggled ? 'rotate(-90deg)' : 'rotate(90deg)')};
  transition: transform 0.3s ease;

  ${({ disabled }) =>
    disabled &&
    `
    path {
      stroke: #e685ad;
    }
    `}
`;

HandleStyled.propTypes = {
  toggled: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

HandleStyled.defaultProps = {
  disabled: false,
};

const BalanceStyled = styled.div`
  margin-top: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #7c6c8a;

  span {
    color: #433a4a;
    font-weight: 600;
  }
`;

const ContentStyled = styled(motion.div)`
  width: 100%;
`;

const PricesDetailsStyled = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  margin: 25px 0;
`;

const AltPriceTextStyled = styled.div`
  width: 100%;
  font-weight: 400;
  font-size: 18px;
  color: #7c6c8a;

  span {
    color: #433a4a;
    font-weight: 500;
  }
`;

const CardIconsWrapperStyled = styled.div`
  text-align: center;
`;

const DisabledWebpayStyled = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 20px;

  svg {
    margin: 0 10px;

    path {
      stroke: #e92070;
    }
  }

  div {
    flex: 1;
    line-height: 15px;
  }
`;

const BalanceDividerStyled = styled.div`
  height: 34px;
  width: 1px;
  background-color: #979797;
`;

const IsRecurringWarningStyled = styled.div`
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  > svg {
    margin-right: 10px;
  }

  > div {
    font-family: cerapro;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #7c6c8a;
    width: fit-content;
  }
`;

const CreditLimitMessageStyled = styled.div`
  display: flex;
  font-size: 14px;
  line-height: 18px;
  color: #494c66;
  padding: 0 10px 16px;
`;

const InfoIconStyled = styled(InfoIcon)`
  margin-right: 9px;
  flex-shrink: 0;
`;

const TextEnrolTDC = styled.p`
  color: #494c66;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
  margin: 10px 0px;
`;

const EnrolAction = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 22px;
  border-top: 1px solid #c9cfd7;

  > p {
    color: #e92070;
    font-size: 16px;
    line-height: 19px;
    font-weight: 500;
  }
`;

export {
  ContainerStyled,
  HeaderStyled,
  HandleStyled,
  BalanceStyled,
  TextStyled,
  ContentStyled,
  PricesDetailsStyled,
  AltPriceTextStyled,
  CardIconsWrapperStyled,
  DisabledWebpayStyled,
  BalanceDividerStyled,
  IsRecurringWarningStyled,
  CreditLimitMessageStyled,
  InfoIconStyled,
  TextEnrolTDC,
  EnrolAction,
  TextInvoice,
};
